import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import Classes from "./types/Classes";
import Employees from "./types/Employees";
import Newsletter from "./types/Newsletter";

export const client = sanityClient({
    projectId: "4f1fpc2v",
    dataset: "production",
    apiVersion: "2021-04-28",
    useCdn: process.env.NODE_ENV !== "development", // `false` if you want to ensure fresh data
});

const builder = imageUrlBuilder(client);

function urlFor(source: SanityImageSource) {
    return builder.image(source);
}

async function getNewsletters() {
    return client.fetch<Newsletter[]>("*[_type == \"newsletter\"] | order(_createdAt desc) {..., \"fileUrl\": file.asset->url}");
}

async function getEmployees() {
    const employees = await client.fetch<Employees>("*[_type == \"employees\"] {...}[0]");
    return employees.employees;
}

async function getClasses() {
    const classes = await client.fetch<Classes[]>("*[_type == \"classes\"] | order(ordinal) {...}");
    return classes;
}

const sanity = {
    client,
    urlFor,
    getNewsletters,
    getEmployees,
    getClasses,
};

export default sanity;
